import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import AlertIconWithCount from 'pages/shared/Alert/IconWithCount'
import AlertsTooltip from 'pages/shared/AlertsTooltip'

import { Device } from 'types/Device'
import { parseAlerts } from 'pages/Device/ThermostatRthPanel/Chart/rthDataParser'

type Props = {
  device: Device
  customerId: string
  alertDetails: ReturnType<typeof parseAlerts>
  alertIds: string
  areAlertsLoaded: boolean
}

const AlertIcons = ({ device, customerId, alertDetails, alertIds, areAlertsLoaded }: Props) => {
  const navigate = useNavigate()

  const { deviceId } = device

  const onClickAlertIcon = () => {
    navigate(`/customers/${customerId}/systems/${deviceId}/alerts`)
  }

  return (
    <>
      <S.Alerts
        onClick={onClickAlertIcon}
        data-tooltip-id={`${deviceId}-alert-tooltip`}
        data-tooltip-content={alertIds}
      >
        <AlertIconWithCount useTooltip={false} severity="critical" count={device.criticalAlertCount} />
        <AlertIconWithCount useTooltip={false} severity="major" count={device.majorAlertCount} />
        <AlertIconWithCount useTooltip={false} severity="minor" count={device.minorAlertCount} />
        <AlertIconWithCount useTooltip={false} severity="critical-sda" count={device.sdaCriticalAlertCount} />
        <AlertIconWithCount useTooltip={false} severity="major-sda" count={device.sdaMajorAlertCount} />
        <AlertIconWithCount useTooltip={false} severity="minor-sda" count={device.sdaMinorAlertCount} />
      </S.Alerts>

      <AlertsTooltip
        id={`${deviceId}-alert-tooltip`}
        alerts={alertDetails}
        isLoaded={areAlertsLoaded}
        place="bottom"
      />
    </>
  )
}

export default AlertIcons

const S = {
  Alerts: styled.div`
    display: flex;
    flex-wrap: wrap;
    max-height: 70px; ${''/* limit the height so when alert icons wrap to the second row, there's not excessive space between rows */}
    cursor: pointer;
  `
}
